import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ActionCard, AppText, Chip, IconBox } from '@zippeditoolsjs/ui-web';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';
import BackLink from '../../ui/controls/BackLink';
import { maskPhoneNumber } from '../../utils/phone';
import { getPhoneHint, getTotpHint } from '../policy/totpChallenge';

export default function MfaMethodChooser({ resolver, onPickTotp, onPickSms, onBack }) {
  const { t } = useTranslation();
  const totpHint = getTotpHint(resolver);
  const phoneHint = getPhoneHint(resolver);

  return (
    <div className="flex flex-col">
      <BackLink onClick={onBack} />
      <AppText variant="titleXLarge" as="h3" className="mb-2">
        {t('heimdal_app.TOTP.choose_method_title')}
      </AppText>
      <AppText variant="bodyMedium" as="p" className="mb-6 text-secondary">
        {t('heimdal_app.TOTP.choose_method_subtitle')}
      </AppText>

      <div className="flex flex-col gap-2.5">
        {totpHint ? (
          <ActionCard
            startAdornment={
              <IconBox size="sm" tone="accent">
                <IconComponent iconName="shield-checkmark" style={{ fontSize: 18 }} />
              </IconBox>
            }
            title={t('heimdal_app.TOTP.authenticator_app')}
            hint={t('heimdal_app.TOTP.method_totp_description')}
            titleAdornment={
              <Chip tone="success">{t('heimdal_app.TOTP.recommended')}</Chip>
            }
            onClick={onPickTotp}
          />
        ) : null}
        {phoneHint ? (
          <ActionCard
            startAdornment={
              <IconBox size="sm" tone="muted">
                <IconComponent
                  iconName="chatbubble-ellipses-outline"
                  style={{ fontSize: 18 }}
                />
              </IconBox>
            }
            title={t('heimdal_app.TOTP.method_sms_title', {
              phone: maskPhoneNumber(phoneHint.phoneNumber),
            })}
            hint={t('heimdal_app.TOTP.method_sms_description')}
            onClick={onPickSms}
          />
        ) : null}
      </div>
    </div>
  );
}

MfaMethodChooser.propTypes = {
  resolver: PropTypes.object,
  onPickTotp: PropTypes.func.isRequired,
  onPickSms: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};
